import React, { forwardRef } from "react";
import TooltipHLPure from "../tooltipHL/tooltipHL.pure";
import { Grid } from "@material-ui/core";
import "./inputHL.css";
import { useState } from "react";

/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const InputHLPure = forwardRef((props, ref) => {
  const {
    labelInput, //Label text from input
    autoFocus, //Set focus in the input
    typeInput, //Type input (text, email, number, etc.)
    valueInput, //If it has a predefined value or a start value
    // validateInput,
    placeholder,
    setSpace,
    handleChangeInput, //Function onChange for value change
    characterLimit, // Text input character limit
    required,
    disabled, //disabled input
    extraContent,
    errorInput, //Error true or false
    errorInputText, //Error text to validate input
    tooltipShow, //True or false to show tooltip
    positionTooltip, //Position tooltip (top, left, right, bottom) string
    titleTooltip, //Title tooltip string
    descriptionTooltip, //Description tooltip string
    subContent, //More text to tooltip description optional
    restContent, //More text to tooltip description optional
    informationIcon, // Choose the information icon true or false to custom img
    inputActive = true, //True to active input with underline, false to send text
    onBlur, //function blur input
    styleGrid,
    styleInput,
    inputTypeBox, // true or false if input type box or false if input has an underline
    showAsText
  } = props;

  //Function, hooks, you can use this to extract the value of the input wherever you are going to use it
  // const [inputValue, setInputValue] = useState(valueInput || "");
  // const [errorInput, setErrorInput] = useState(false);

  // const handleChange = (event) => {
  //   if (event.target.value === undefined || event.target.value === "") {
  //     setErrorInput(true);
  //   } else {
  //     setInputValue(event.target.value);
  //   }
  // };

  const [chars, setChars] = useState(0);

  const onLimitedTextChange = (event) => {
    setChars(event.target.value.length);
    handleChangeInput(event);
  }

  return (
    <Grid
      item
      xs={12}
      className="inputHLPure-container"
      style={styleGrid}
    >
      <div className="inputHLPure-container-text"
        style={setSpace ? { justifyContent: "space-between" } : null}
      >
        {labelInput &&
          <label htmlFor={props.id} className="eticket-form-label" name="label">
            {labelInput} {required && "*"}
          </label>}

        {tooltipShow ? (
          <TooltipHLPure
            positionTooltip={positionTooltip}
            titleTooltip={titleTooltip}
            descriptionTooltip={descriptionTooltip}
            subContent={subContent}
            restContent={restContent}
            informationIcon={informationIcon}
          />
        ) : (
          ""
        )}
        {extraContent}
      </div>
      {inputActive ? (
        <input
          {...props}
          autoFocus={autoFocus}
          type={typeInput}
          required={required}
          className={`${inputTypeBox ? "inputHLPure-input-type-box" : "eticket-input-field"} ${errorInput ? "inputHLPure-error" : ""} ${showAsText ? "inputHLPure-showAsText" : ""}`}
          name={props.name || "inputValue"}
          value={typeof valueInput === "string" ? valueInput.trimStart() : valueInput ?? undefined}
          onChange={typeInput == "text" && characterLimit ? onLimitedTextChange : handleChangeInput}
          onBlur={onBlur}
          // component={validateInput}
          disabled={disabled}
          style={styleInput}
          maxLength={characterLimit}
          placeholder={placeholder}
          ref={ref}
        />
      ) : (
        <p className="inputHLPure-readOnlyText">{valueInput}</p>
      )}
      <div className="inputHLPure-hints">
        {errorInput && (
          <span className="hint-message-error">{errorInputText}</span>
        )}
        {typeInput == "text" && characterLimit && (
          <span className="character-limit">{chars}/{characterLimit}</span>
        )}
      </div>
    </Grid>
  );
});

export { InputHLPure as default };
